import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(utc);

const FeaturedProject = ({ project, onDonate }) => {
  const progressPercentage = (project?.raised / project?.target) * 100;
  const daysLeft = Math.ceil(
    (new Date(project.deadline) - new Date()) /
      (1000 * 60 * 60 * 24)
  );

  return (
    <div className="bg-gradient-trust bg-white rounded-xl overflow-hidden shadow-warm-hover mb-8">
      <div className="grid lg:grid-cols-2">
        {/* Image Section */}
        <div className="relative h-[260px] sm:h-[360px] lg:h-full lg:min-h-[400px]">
          <Image
            src={project?.image}
            alt={project?.title}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Content Section */}
        <div className="p-5 sm:p-6 md:p-8 text-white flex flex-col justify-between">
          <div className="mb-6">
            <div className="inline-flex items-center px-3 py-1 rounded-full text-[11px] sm:text-xs font-medium bg-black/20 text-white mb-3">
              {project?.category}
            </div>

            <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-3xl text-foreground leading-tight mb-3">
              {project?.title}
            </h2>

            <p className="text-sm sm:text-base lg:text-lg text-muted-foreground leading-relaxed">
              {project?.description}
            </p>
          </div>

          {/* Action Button */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="default"
              size="lg"
              className="bg-secondary hover:bg-conversion-orange/90 text-white shadow-button w-full"
              onClick={() => onDonate(project)}
            >
              Donate to This Project
            </Button>
          </div>

          {/* Last Update */}
          <div className="mt-5 pt-5 border-t border-white/20">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs sm:text-sm text-muted-foreground">
              <span>
                Last updated:{' '}
                {project?.last_updated
                  ? dayjs.utc(project.last_updated).local().fromNow()
                  : dayjs.utc(project?.created_at).local().fromNow()}
              </span>

              <div className="flex items-center gap-1">
                <Icon
                  name="MapPin"
                  size={14}
                />
                <span>{project?.location}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedProject;